/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityTorrentsResult } from './ControlEntityTorrentsResult';
import {
    ControlEntityTorrentsResultFromJSON,
    ControlEntityTorrentsResultFromJSONTyped,
    ControlEntityTorrentsResultToJSON,
} from './ControlEntityTorrentsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityTorrentsResponse
 */
export interface ControlPaginatedEntityTorrentsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTorrentsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTorrentsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTorrentsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityTorrentsResult>}
     * @memberof ControlPaginatedEntityTorrentsResponse
     */
    results?: Array<ControlEntityTorrentsResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityTorrentsResponse interface.
 */
export function instanceOfControlPaginatedEntityTorrentsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityTorrentsResponseFromJSON(json: any): ControlPaginatedEntityTorrentsResponse {
    return ControlPaginatedEntityTorrentsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityTorrentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityTorrentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityTorrentsResultFromJSON)),
    };
}

export function ControlPaginatedEntityTorrentsResponseToJSON(value?: ControlPaginatedEntityTorrentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityTorrentsResultToJSON)),
    };
}

